import { slugFormat } from '../../../utils/functions';

export const urlFormatted = (url: any) => {
  const { city, name, id, state } = url;
  return slugFormat(`/loja/${state}/${city}/${name}/${id}`);
};
